import { getSessionId } from '@lwtears/lwt-common-frontend/lib/@common';
import store from '../store';
import { createEvent } from 'utils/api';

class InactivityManager {
  constructor(duration, callback, reason) {
    this.reason = reason;
    this.duration = duration;
    this.callback = callback;
    this.lastCalledWithArgs = { duration, callback, skip: false };
    this.timers = [];
  }

  watch(duration = this.duration, callback = this.callback, reason = this.reason, skip = false) {
    this.lastCalledWithArgs = { duration, callback, skip };
    this.timers.push(
      setTimeout(() => {
        const {
          ui: { module }
        } = store.getState();

        // if there is no session do not attempt to log the event
        if (getSessionId()) {
          createEvent('inactivity', { reason, module });
        }

        if (callback) {
          this.callbackAudioResult = callback();
        }

        if (skip) return;
        this.watch(duration, callback, reason, true);
      }, duration)
    );
  }

  rewatch() {
    const { duration, callback, reason, skip } = this.lastCalledWithArgs;
    this.watch(duration, callback, reason, skip);
  }

  stopAudio() {
    if (this.callbackAudioResult && this.callbackAudioResult.stop) {
      this.callbackAudioResult.stop();
    }
  }

  clear() {
    this.timers.forEach(id => clearTimeout(id));
  }
}

export default InactivityManager;
